(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["installment-info"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.NSInstallments) return;

  // Bundle set prices by source (page builder / mobile sheet / Pop Mart upsell);
  // the most recent complete set wins.
  var bundleTotals = {};
  var bundleOrder = [];

  function formatMoney(cents, format) {
    var value = Math.max(0, Math.round(cents)) / 100;
    function group(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    // Fallback mirrors shop.money_format (comma-separator amount + €); braces split so it is not read as Liquid.
    return (format || '{' + '{amount_with_comma_separator}' + '}€').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return group(value, 2, ',', '.');
      }
    });
  }

  function activeBundleTotal() {
    for (var i = bundleOrder.length - 1; i >= 0; i--) {
      var cents = bundleTotals[bundleOrder[i]];
      if (typeof cents === 'number') return cents;
    }
    return null;
  }

  function render(root) {
    var cents = parseInt(root.getAttribute('data-price'), 10) || 0;
    var bundle = root.hasAttribute('data-bundle-aware') ? activeBundleTotal() : null;
    if (bundle !== null) cents = bundle;
    var format = root.getAttribute('data-money-format');
    var feePct = parseFloat(root.getAttribute('data-fee-pct')) || 0;

    root.querySelectorAll('[data-inst]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-inst'), 10) || 1;
      el.textContent = formatMoney(Math.floor(cents / n), format);
    });
    var fee = Math.round(cents * feePct / 100);
    root.querySelectorAll('[data-inst-first]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-inst-first'), 10) || 1;
      var first = cents - (n - 1) * Math.floor(cents / n);
      // Scalapay's 4-plan fee is charged with the first installment.
      if (el.hasAttribute('data-inst-add-fee')) first += fee;
      el.textContent = formatMoney(first, format);
    });
    root.querySelectorAll('[data-inst-fee]').forEach(function (el) {
      el.textContent = formatMoney(fee, format);
    });
    root.querySelectorAll('[data-inst-total]').forEach(function (el) {
      el.textContent = formatMoney(cents, format);
    });
    root.querySelectorAll('[data-inst-bundle-note]').forEach(function (el) {
      el.hidden = bundle === null;
    });
  }

  function selectTab(dialog, name) {
    dialog.querySelectorAll('[data-inst-tab]').forEach(function (tab) {
      tab.setAttribute('aria-selected', tab.getAttribute('data-inst-tab') === name ? 'true' : 'false');
    });
    dialog.querySelectorAll('[data-inst-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-inst-panel') !== name;
    });
  }

  function openDialog(root) {
    var dialog = root.querySelector('.installments-dialog');
    if (!dialog || dialog.open) return;
    var first = dialog.querySelector('[data-inst-tab]');
    if (first) selectTab(dialog, first.getAttribute('data-inst-tab'));
    render(root);
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('installments-lock');
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      document.documentElement.classList.remove('installments-lock');
    }
  }

  window.NSInstallments = {
    update: function (target, cents) {
      var roots = typeof target === 'string' ? document.querySelectorAll(target) : [target];
      Array.prototype.forEach.call(roots, function (root) {
        if (!root || typeof cents !== 'number' || isNaN(cents)) return;
        root.setAttribute('data-price', cents);
        render(root);
      });
    },
    formatMoney: formatMoney
  };

  document.addEventListener('product:variant-change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    window.NSInstallments.update('[data-installments][data-follow-variant]', variant.price);
  });

  document.addEventListener('installments:bundle-total', function (e) {
    var detail = e.detail || {};
    if (!detail.source) return;
    bundleOrder = bundleOrder.filter(function (s) { return s !== detail.source; });
    if (typeof detail.cents === 'number' && detail.cents > 0) {
      bundleTotals[detail.source] = detail.cents;
      bundleOrder.push(detail.source);
    } else {
      delete bundleTotals[detail.source];
    }
    document.querySelectorAll('[data-installments][data-bundle-aware]').forEach(render);
  });

  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-inst-open]');
    if (opener) {
      // The row can sit inside a product link or form; it must only open the details.
      e.preventDefault();
      // Mouse: only the info icon opens it (keyboard activation has detail 0).
      if (finePointer && finePointer.matches && e.detail !== 0 && !e.target.closest('.installments__info')) return;
      openDialog(opener.closest('[data-installments]'));
      return;
    }
    var tab = e.target.closest('[data-inst-tab]');
    if (tab) {
      selectTab(tab.closest('.installments-dialog'), tab.getAttribute('data-inst-tab'));
      return;
    }
    var closer = e.target.closest('[data-inst-close]');
    if (closer) {
      closeDialog(closer.closest('.installments-dialog'));
      return;
    }
    // Click on the backdrop (outside the box) closes the dialog.
    if (e.target.classList && e.target.classList.contains('installments-dialog')) {
      closeDialog(e.target);
    }
  });

  document.addEventListener('close', function (e) {
    if (e.target.classList && e.target.classList.contains('installments-dialog')) {
      document.documentElement.classList.remove('installments-lock');
    }
  }, true);

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["loyalty-product-points"] && !Shopify.designMode) return;
  try {
    (function () {
    // Each line keeps what it shows for its product (the cheapest or the
    // picked size) in `loyaltyBase`; a complete bundle shows on top of it and
    // the base comes back when the bundle is broken up.
    function show(root, points, exact) {
      root.hidden = points <= 0;
      root.querySelectorAll('[data-loyalty-points]').forEach(function (el) {
        el.textContent = points;
      });
      root.querySelector('[data-loyalty-points-from]').hidden = exact;
      root.querySelector('[data-loyalty-points-exact]').hidden = !exact;
    }

    // Prices on a page in another currency are converted from euros; Steps are earned on euros.
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    function toEuros(points) {
      return Math.floor(points / rate + 0.000001);
    }

    function variantPoints(root) {
      if (!root.loyaltyPoints) {
        var map = JSON.parse(root.getAttribute('data-points') || '{}');
        if (root.hasAttribute('data-loyalty-rescale')) {
          Object.keys(map).forEach(function (id) {
            map[id] = toEuros(map[id]);
          });
        }
        root.loyaltyPoints = map;
      }
      return root.loyaltyPoints;
    }

    // The first number rendered in another currency, back in euros (the line waits hidden).
    function rescaleInitial() {
      document.querySelectorAll('[data-loyalty-product-points][data-loyalty-rescale]').forEach(function (root) {
        if (root.loyaltyRescaled) return;
        root.loyaltyRescaled = true;
        var shown = parseInt(root.querySelector('[data-loyalty-points]').textContent, 10) || 0;
        show(root, toEuros(shown), root.querySelector('[data-loyalty-points-from]').hidden);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rescaleInitial);
    else rescaleInitial();

    // The picker that fires depends on the template: variant-selects
    // (product.js), the size grids of the inline buy box / sticky bar
    // (main-product), the option radios (product-option). Each sends the variant.
    function onVariant(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      document.querySelectorAll('[data-loyalty-product-points]').forEach(function (root) {
        var points = variantPoints(root)[variant.id];
        // Another product's variant (quick add, bundles): not ours.
        if (typeof points !== 'number') return;
        root.loyaltyBase = { points: points, exact: true };
        if (!root.loyaltyBundle) show(root, points, true);
      });
    }
    ['product:variant-change', 'sticky-cart:variant:change', 'pdp:variant:change'].forEach(function (name) {
      document.addEventListener(name, onVariant);
    });

    // Steps per € of a variant: this product's from data-factor, a bundle
    // item's from its builder group (data-loyalty-factor).
    function factorOf(root, variantId) {
      if (typeof variantPoints(root)[variantId] === 'number') return parseFloat(root.getAttribute('data-factor')) || 0;
      var btn = document.querySelector('.bundle-builder__size-btn[data-variant-id="' + variantId + '"]');
      var group = btn && btn.closest('[data-loyalty-factor]');
      return group ? parseFloat(group.getAttribute('data-loyalty-factor')) || 0 : 0;
    }

    // bundle-promotion.js: source 'sheet' (the size sheet's set mode) or
    // 'builder' (the page's bundle builder); cents null = no complete set.
    document.addEventListener('installments:bundle-total', function (e) {
      var d = e.detail || {};
      var context = d.source === 'sheet' ? 'sheet' : d.source === 'builder' ? 'page' : null;
      if (!context) return;
      document.querySelectorAll('[data-loyalty-product-points][data-loyalty-context="' + context + '"]').forEach(function (root) {
        if (!root.loyaltyBase) {
          var from = !root.querySelector('[data-loyalty-points-from]').hidden;
          root.loyaltyBase = { points: parseInt(root.querySelector('[data-loyalty-points]').textContent, 10) || 0, exact: !from };
        }
        if (d.cents == null || !d.lines || !d.lines.length) {
          root.loyaltyBundle = false;
          show(root, root.loyaltyBase.points, root.loyaltyBase.exact);
          return;
        }
        var keep = 1 - (d.pct > 0 ? d.pct / 100 : 0);
        var exact = d.lines.reduce(function (sum, line) {
          return sum + (line.cents / 100 / rate) * keep * factorOf(root, line.variantId);
        }, 0);
        root.loyaltyBundle = true;
        // Same rounding as next-table: down, ignoring float noise.
        show(root, Math.floor(exact + 0.000001), true);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["render-feature-block"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__featureBlockTrackerBound) return;
    window.__featureBlockTrackerBound = true;
    var SELECTOR = '[data-track-event="pdp_feature_block_clicked"]';
    // Shopify Customer Events (sandboxed pixel) — see custom pixel "Feature Block Click Tracker"
    function publish(eventName, el) {
      if (!(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function')) return;
      window.Shopify.analytics.publish(eventName, {
        block_title: el.dataset.blockTitle || '',
        page_location: window.location.href,
        page_path: window.location.pathname
      });
    }
    document.addEventListener('click', function(e) {
      var el = e.target.closest(SELECTOR);
      if (el) publish('pdp_feature_block_clicked', el);
    });
    // Impressions: once per block per page view, when at least half of it is on screen
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          publish('pdp_feature_block_viewed', entry.target);
        });
      }, { threshold: 0.5 });
      var observeAll = function() {
        document.querySelectorAll(SELECTOR).forEach(function(el) {
          if (el.dataset.viewTracked) return;
          el.dataset.viewTracked = '1';
          observer.observe(el);
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeAll);
      else observeAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-button"] && !Shopify.designMode) return;
  try {
    (function () {
    function syncWhatsappWithStickyCart() {
      var stickyCart = document.getElementById('EnhancedStickyCart');
      if (!stickyCart) return;

      function update() {
        var active = stickyCart.classList.contains('visible');
        document.body.classList.toggle('sticky-cart-active', active);
      }

      update();
      new MutationObserver(update).observe(stickyCart, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncWhatsappWithStickyCart);
    } else {
      syncWhatsappWithStickyCart();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
